<template>
	<v-storyblok-rich-text v-if="blok.type === 'doc'" :document="blok.body" />

	<!-- From @storyblok/vue -->
	<storyblok-component
		v-else-if="blok.component"
		:blok="blok"
		:options="options"
		:component-index="componentIndex"
	/>
</template>

<script setup lang="ts">
defineProps<{
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- the resolved blok can be any registered Storyblok component
	blok: any;
	options?: Record<string, unknown>;
	componentIndex?: number;
}>();

// NOTE: Not needed yet. Could be useful if we want to implement our own nuxt-picture component that wraps the default nuxt-picture component but handles image loading priorities automatically
// This is context that's possibly needed at deep levels in the component hierarchy (such as rendering pictures with high fetch priority if component index is small) and that is safe to expose (in contrast for example exposing the entire related story might lead to bad practices).
// const context = reactive({ componentIndex: props.componentIndex });
//
// provide('sbPageContext', context);
</script>
